import { Navigate, useParams } from 'react-router'
import { PERMISSION_ACTION_EDIT, ROUTE_ORDERS, ROUTE_ORDER_EVENTS, parseOrderIdFromDisplay } from '@klear/constants'
import OrderDetail from '@/app/order/OrderDetail'

interface OrderIdDisplayRedirectProps {
  appPrefix: string
  isEditing?: boolean
}

export default function OrderIdDisplayRedirect({ appPrefix, isEditing = false }: OrderIdDisplayRedirectProps) {
  const { idDisplay = '' } = useParams()

  if (parseOrderIdFromDisplay(idDisplay) != null) {
    if (isEditing) return <Navigate to={`/${ROUTE_ORDERS}/${idDisplay}`} replace />
    return <OrderDetail appPrefix={appPrefix} orderIdDisplay={idDisplay} />
  }

  const editSuffix = isEditing ? `/${PERMISSION_ACTION_EDIT}` : ''
  return <Navigate to={`/${ROUTE_ORDER_EVENTS}/${idDisplay}${editSuffix}`} replace />
}
